module.exports = __webpack_public_path__ + "img/american-credit-google-review-micah-cohen.9107c80.webp";